export class ErrorPatternRenderer {

    constructor(p_jstemplatecenter, p_basicConfiguration) {
        this.jstemplatecenter = p_jstemplatecenter;
        this.basicConfiguration = p_basicConfiguration;
    }

    render(p_document, p_templateName, p_embedded) {
        if(!p_embedded) {
            this.basicConfiguration.documentRenderer.documentRendered = true;
        }
        return this.jstemplatecenter.templates[p_templateName](p_document);
    }
}